import React from "react";
import { Box } from "@mui/material";

const Cards7 = () => {
  const layout = [
    { num: 3, col: 3, row: 1 },
    { num: 1, col: 1, row: 2 },
    { num: 6, col: 5, row: 2 },
    { num: 4, col: 3, row: 3 },
    { num: 2, col: 1, row: 4 },
    { num: 7, col: 5, row: 4 },
    { num: 5, col: 3, row: 5 },
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 30px)",
        gridTemplateRows: "repeat(5, 30px)",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: 2,
      }}
    >
      {layout.map(({ num, col, row }) => (
        <Box
          key={num}
          sx={{
            gridColumn: col,
            gridRow: row,
            width: 43,
            height: 54,
            backgroundColor: "#1976d2",
            borderRadius: "10px",
            color: "white",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            userSelect: "none",
          }}
        >
          {num}
        </Box>
      ))}
    </Box>
  );
};

export default Cards7;
